let menuToggle = () => {
  let self = {}
  self.ui = {}
  self.open = false

  const functionMap = {
    toggle: 'toggle',
    show: 'add',
    hide: 'remove'
  }

  const init = () => {
    bindUI().then(() => {
      watchUI()
    })
  }

  const bindUI = () => {
    return new Promise((resolve, reject) => {
      self.ui.button = document.querySelector('#menu-toggle')
      self.ui.menu = document.querySelector('#main-menu')

      !!(self.ui.button && self.ui.menu) ? resolve(true) : reject(new Error('No button found.'))
    })
  }

  const watchUI = () => {
    self.ui.button.addEventListener('click', (event) => {
      event.preventDefault();
      collapse(self.ui.button.dataset.target, 'toggle');
    })
  }

  const collapse = (selector, cmd) => {
    const targets = Array.from(document.querySelectorAll(selector));
    targets.forEach(target => {
      target.classList[functionMap[cmd]]('show');
    });
  }

  init()

  return self
}
new menuToggle()
